const AUTH_KEYS = ['hrpocket_auth', 'hrpocket_admin_auth', 'token', 'user'];

export function readWebSession() {
  for (const storage of [localStorage, sessionStorage]) {
    try {
      const auth = JSON.parse(storage.getItem('hrpocket_auth') || 'null');
      if (auth?.token && auth?.user) return auth;
    } catch (_) {}
  }
  return null;
}

export function writeWebSession(auth, remember = true) {
  const target = remember ? localStorage : sessionStorage;
  for (const storage of [localStorage, sessionStorage]) {
    for (const key of AUTH_KEYS) storage.removeItem(key);
  }
  target.setItem('hrpocket_auth', JSON.stringify(auth));
  target.setItem('hrpocket_admin_auth', JSON.stringify(auth));
  target.setItem('token', auth.token);
  target.setItem('user', JSON.stringify(auth.user));
}

export function restoredPortalPath(pathname, search = '', hash = '') {
  if (pathname !== '/' || search || hash) return pathname;
  const auth = readWebSession();
  if (!auth) return pathname;
  return ['employee', 'superadmin'].includes(auth.user.role) ? '/admin' : '/dashboard';
}
